/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Restart_NowInputs */

const en_mobile_dev_backend_restart_now = /** @type {(inputs: Mobile_Dev_Backend_Restart_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart now`)
};

const es_mobile_dev_backend_restart_now = /** @type {(inputs: Mobile_Dev_Backend_Restart_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar ahora`)
};

/**
* | output |
* | --- |
* | "Restart now" |
*
* @param {Mobile_Dev_Backend_Restart_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_restart_now = /** @type {((inputs?: Mobile_Dev_Backend_Restart_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Restart_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_restart_now(inputs)
	return en_mobile_dev_backend_restart_now(inputs)
});